import React from 'react';

import { Horizon, HorizonItem } from '../horizon-item/HorizonItem';
import * as S from './HorizonSelector.styles';

export const HorizonSelector = ({
  horizons,
  selectedHorizon,
  handleHorizonChange,
  horizonToIndexMap,
  benchmarkTags,
  themeId,
}: {
  horizons: Horizon[];
  selectedHorizon: Horizon;
  handleHorizonChange: (horizon: Horizon) => void;
  horizonToIndexMap: Map<string, number>;
  benchmarkTags?: string[];
  themeId: string;
}) => {
  return (
    <S.Root>
      {horizons.map(horizon => (
        <HorizonItem
          key={horizon}
          horizonToIndexMap={horizonToIndexMap}
          horizon={horizon}
          isSelected={horizon === selectedHorizon}
          benchmarkTags={benchmarkTags}
          onClick={() => handleHorizonChange(horizon)}
          themeId={themeId}
        />
      ))}
    </S.Root>
  );
};
